import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function LeadTime(props) {
  return (
    <SvgIcon width="18" height="17" viewBox="0 0 18 17" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00016 2.12504C5.47935 2.12504 2.62516 4.97923 2.62516 8.50004C2.62516 12.0209 5.47935 14.875 9.00016 14.875C12.521 14.875 15.3752 12.0209 15.3752 8.50004C15.3752 4.97923 12.521 2.12504 9.00016 2.12504ZM1.2085 8.50004C1.2085 4.19682 4.69694 0.708374 9.00016 0.708374C13.3034 0.708374 16.7918 4.19682 16.7918 8.50004C16.7918 12.8033 13.3034 16.2917 9.00016 16.2917C4.69694 16.2917 1.2085 12.8033 1.2085 8.50004Z"
        fill="#007F33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00016 3.54171C9.39136 3.54171 9.7085 3.85884 9.7085 4.25004V8.06227L12.1503 9.28315C12.5002 9.45811 12.642 9.88358 12.467 10.2335C12.2921 10.5834 11.8666 10.7252 11.5167 10.5503L8.68339 9.13359C8.44341 9.01361 8.29183 8.76834 8.29183 8.50004V4.25004C8.29183 3.85884 8.60896 3.54171 9.00016 3.54171Z"
        fill="#007F33"
      />
    </SvgIcon>
  );
}
